<template>
  <div class="layout-content">
    <fx-table v-if="$slots.utable">
       <slot name="utable"></slot>
    </fx-table>
    <div class="layout-content-main">
      <router-view></router-view>
    </div>
  </div>
</template>
<script setup lang="ts">
import FxTable from './table.vue';
const props = defineProps({
  config: {  // 配置项
    type: Object,
    default: {},
  },
});
const { config } = props
</script>
<style lang="less">
.layout-content{
  flex-grow: 1;
  flex-shrink: 1;
  z-index: 0;
  padding: 0;
  margin: 0;
  position: relative;
  // 
  height: calc(100vh - 60px);
  font-size: 14px;

  .layout-content-main{
    height:calc(100% - 44px);
    box-shadow: 0 0 8px #0003;
  }
}
</style>